module.exports = __webpack_public_path__ + "assets/img/scss_ampersand.366ddeaf.jpg";